import { prefs } from './prefs';
import type { StreamConfig } from '../types/stream';

// Persist a completed authentication (pairing, login, or zero-touch provision)
// to local storage. setToken/setUuid/setDeviceId also mirror into the
// localStorage credential backup (see prefs.ts / credentialBackup.ts).
export async function persistAuth(
  token: string,
  uuid: string,
  deviceId: number,
  cfg: StreamConfig | null,
): Promise<void> {
  await prefs.setToken(token);
  if (uuid) await prefs.setUuid(uuid);
  if (deviceId) await prefs.setDeviceId(deviceId);
  if (cfg) await prefs.setConfig(cfg);
}
